<h1>Sandbox</h1>

<section>
  <input type="file" accept="image/*" capture="environment">
</section>

<section>
    <h2>Errors</h2>

    <ul>
        @for (error of errors(); track error) {
            @for (item of error; track item) {
                {{item?.toString()}}
            }
        }
    </ul>
</section>
